import { IDSK } from "@examspark/types";

import * as fragments from "../../fragments/resource";
import { getResource } from "../resource";

export const getItemForPlayer = async (params: IDSK) => {
  return (
    await getResource({
      label: "GetItemDataForPlayer",
      variables: params,
      fields: `
      ${fragments.id}
      ${fragments.basic}
      ${fragments.itemContent}
      ${fragments.contexts}
      alignmentIds
    `,
    })
  ).data?.getResource;
};

export const getItemAlignments = async (params: IDSK) => {
  return (
    await getResource({
      label: "GetItemAlignments",
      variables: params,
      fields: `
      id
      sk
      ${fragments.alignments}
      __typename
    `,
    })
  ).data?.getResource;
};

export const getItemDetails = async (params: IDSK) => {
  return (
    await getResource({
      label: "GetItemDataForPlayer",
      variables: params,
      fields: `
      id
      idInc
      idVendor
      sk
      type
      version
      bankId
      name
      description
      author
      maturity
      subject
      grade
      dok
      language
      blooms
      excerpt
      interaction
      dueAt
      editorId
      creatorId
      questionIds
      contextIds
      schemaVersion
      createdAt
      updatedAt
      workspaceId
      alignmentIds
      ${fragments.alignmentsAbbrs}
      isUserFavorite
      isUserWatcher
      content {
        canvas {
          id
          type
          interactionType
          content
          config
          scoring
        }
      }
      scoring
      config
      contexts {
        items {
          id
          sk
          type
          idInc
          name
          content {
            body
          }
        }
      }
      file {
        bucket
        name
        key
        size
      }
      __typename
    `,
    })
  ).data?.getResource;
};
